
import React from 'react';
import { format } from 'date-fns';
import { FileText } from 'lucide-react';
import { AdaptiveModal } from '@/components/ui/AdaptiveModal';
import { useHaptics } from '@/hooks/useHaptics';
import { MealInfo } from './daily-tile';
import MealItemTile from './daily-tile/MealItemTile';

interface ViewAllMealsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  date: Date;
  meals: MealInfo[];
}

const ViewAllMealsDialog: React.FC<ViewAllMealsDialogProps> = ({
  open,
  onOpenChange,
  date,
  meals
}) => {
  const dateString = format(date, 'MMM d');
  const { lightImpact } = useHaptics();

  const handleClose = () => {
    lightImpact();
    onOpenChange(false);
  };

  // Define meal type order and sort meals
  const mealTypeOrder = { breakfast: 0, lunch: 1, dinner: 2 };
  const sortedMeals = [...meals].sort((a, b) => {
    const aOrder = mealTypeOrder[a.mealType as keyof typeof mealTypeOrder] ?? 3;
    const bOrder = mealTypeOrder[b.mealType as keyof typeof mealTypeOrder] ?? 3;
    return aOrder - bOrder;
  });

  return (
    <AdaptiveModal
      isOpen={open}
      onClose={handleClose}
      title={`Meals for ${dateString}`}
      size="md"
      scrollable={true}
    >
      <div className="space-y-2">
        {sortedMeals.map((meal) => (
          <MealItemTile 
            key={`${meal.type}-${meal.id}`} 
            meal={meal}
            showMealType={true}
          />
        ))}
        {sortedMeals.length === 0 && (
          <div className="text-center py-8">
            <FileText className="h-12 w-12 text-muted-foreground mx-auto mb-3" />
            <p className="text-muted-foreground">No meals planned for this day</p>
          </div>
        )}
      </div>
    </AdaptiveModal>
  );
};

export default ViewAllMealsDialog;
